export function selectLastSnoozedDate(state) {
  const { tickets: { lastSnoozedDate } = {} } = state || {}

  if (lastSnoozedDate && lastSnoozedDate > new Date().getTime()) {
    return lastSnoozedDate
  }

  return null
}
